import React, { ReactNode, useState, useEffect } from "react";
import classNames from "classnames";
import ArrowIcon from "../../assets/images/icons/chevron-down.svg";

interface AccordionItemProps {
  title: string | ReactNode;
  children: ReactNode;
  titleIcon?: string;
  expandAll?: boolean;
  totalClass?: string;
  iconClass?: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  titleIcon,
  children,
  expandAll = false,
  totalClass = "",
  iconClass,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (expandAll) {
      setIsOpen(true);
    }
  }, [expandAll]);

  return (
    <div className={` ${isOpen ? `border-b` : ""} ${totalClass}`}>
      <button
        onClick={toggleAccordion}
        className={`flex w-full items-center justify-between py-4 text-left focus:outline-none`}
      >
        <div className="flex items-center gap-2">
          {titleIcon && (
            <img
              src={titleIcon}
              className={`h-10 w-10 ${iconClass}`}
              alt={titleIcon}
            />
          )}
          <span className="text-base font-bold">{title}</span>
        </div>
        <span
          className={classNames("transform transition-transform duration-300", {
            "rotate-180": isOpen,
          })}
        >
          <img alt="arrow" className="w-8" src={ArrowIcon} />
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-screen" : "max-h-0"
        }`}
      >
        <div className={`pb-4`}>{children}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
